import React from "react";

const Skeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      {/* Header skeleton - Number + Title */}
      <div className="flex items-baseline gap-2">
        <div className="h-9 w-10 animate-pulse rounded bg-gray-200" />
        <div className="h-6 w-64 animate-pulse rounded bg-gray-200" />
      </div>

      {/* Filter pills skeleton */}
      <div className="flex gap-2">
        <div className="h-8 w-[80px] animate-pulse rounded-full bg-gray-200" />
        <div className="h-8 w-[100px] animate-pulse rounded-full bg-gray-200" />
        <div className="h-8 w-[120px] animate-pulse rounded-full bg-gray-200" />
        <div className="h-8 w-[140px] animate-pulse rounded-full bg-gray-200" />
        <div className="h-8 w-[160px] animate-pulse rounded-full bg-gray-200" />
      </div>

      {/* Date group and cards skeleton */}
      <div className="flex flex-col gap-4">
        {/* Today group */}
        <div className="flex flex-col gap-3">
          <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
          <div className="flex flex-col gap-3">
            {[1].map((i) => (
              <div
                key={`today-${i}`}
                className="flex items-start gap-3 rounded-xl border border-gray-100 p-4"
              >
                <div className="h-10 w-10 animate-pulse rounded-lg bg-gray-200" />
                <div className="flex flex-1 flex-col gap-2">
                  <div className="h-5 w-4/5 animate-pulse rounded bg-gray-200" />
                  <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Yesterday group */}
        <div className="flex flex-col gap-3">
          <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
          <div className="flex flex-col gap-3">
            {[1].map((i) => (
              <div
                key={`yesterday-${i}`}
                className="flex items-start gap-3 rounded-xl border border-gray-100 p-4"
              >
                <div className="h-10 w-10 animate-pulse rounded-lg bg-gray-200" />
                <div className="flex flex-1 flex-col gap-2">
                  <div className="h-5 w-3/4 animate-pulse rounded bg-gray-200" />
                  <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
